import Vue from 'vue'
import Router from 'vue-router'
import util from '@/libs/utils'
import { getid, setopenid } from '@/service/getdata'
import { appid, appName} from '@/service/config'

const getUserInfo = () => import('@/pages/getUserInfo/index')
const loading = () => import('@/pages/loading/index') // 载入页
const home = () => import('@/pages/home/index') // 首页
const apply = () => import('@/pages/apply/index') // 选择认证
const logon = () => import('@/pages/apply/logon') // 用户登录
const identity = () => import('@/pages/person/identity') // C端认证
const wait = () => import('@/pages/person/wait') // 审核已提交
const fail = () => import('@/pages/person/fail') // 审核未通过
const enterprise = () => import('@/pages/enterprise/identity') // B端认证
const c_login = () => import('@/pages/clerk/login') // 营业员登录
const myOrder = () => import('@/pages/clerk/myOrder') // 营业员核审中心
const getorderhall = () => import('@/pages/clerk/getorderhall') // 抢单大厅
const situation = () => import('@/pages/clerk/situation') // 业务情况
const borrowmoney = () => import('@/pages/clerk/borrowmoney') // 借款管理
const posDetails = () => import('@/pages/clerk/posDetails') // 订单详情
const Review = () => import('@/pages/clerk/Review') // 店审数据采集
const Reviewlook = () => import('@/pages/clerk/Reviewlook') // 查看店审数据
const my = () => import('@/pages/my/index') // 用户“我的”
const xieyi = () => import('@/pages/xieyi/index') // 用户协议页
const bankcard = () => import('@/pages/my/bankcard') // 我的银行卡
const replacecard = () => import('@/pages/my/replacecard') // 更换银行卡
const newlogin = () => import('@/pages/newList/login') //
const neworder = () => import('@/pages/newList/order') //

// 风乐玛
const productList = () => import('@/pages/product/index') // 产品列表
const productHome = () => import('@/pages/product/home') // 首页
const productDetail = () => import('@/pages/product/detail') // 产品详情
const searchProduct = () => import('@/pages/product/search')
const myteam = () => import('@/pages/my/team') // 我的团队
const productPromotion = () => import('@/pages/product/promotion') // 产品推广
const popularize = () => import('@/pages/popularize/index') // 推广
const material = () => import('@/pages/popularize/material') // 推广素材
const promoteLogin = () => import('@/pages/product/login') // 推广员注册
const myCard = () => import('@/pages/my/myCard') // 我的银行卡
const myApply = () => import('@/pages/my/apply') // 我的申请记录

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/loading'
    },
    {
      path: '/productHome',
      name: 'productHome',
      component: productHome
    },
    {
      path: '/productList',
      name: 'productList',
      component: productList
    },
    {
      path: '/searchProduct',
      name: 'searchProduct',
      component: searchProduct
    },
    {
      path: '/productPromotion',
      name: 'productPromotion',
      component: productPromotion
    },
    {
      path: '/productDetail',
      name: 'product',
      component: productDetail
    },
    {
      path: '/popularize',
      name: 'popularize',
      component: popularize
    },
    {
      path: '/material',
      name: 'material',
      component: material
    },
    {
      path: '/myteam',
      name: 'myteam',
      component: myteam
    },
    {
      path: '/promoteLogin',
      name: 'promoteLogin',
      component: promoteLogin
    },
    {
      path: '/myApply',
      name: 'myApply',
      component: myApply
    },
    {
      path: '/myCard',
      name: 'myCard',
      component: myCard
    },
    // ---- 1期
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: home
    // },
    {
      path: '/loading',
      name: 'loading',
      component: loading
    },
    {
      path: '/getUserInfo',
      name: 'getUserInfo',
      component: getUserInfo
    },
    {
      path: '/apply',
      name: 'apply',
      component: apply
    },
    {
      path: '/logon',
      name: 'logon',
      component: logon,
      meta: {
        title: '用户登录'
      }
    },
    {
      path: '/identity',
      name: 'identity',
      component: identity
    },
    {
      path: '/wait',
      name: 'wait',
      component: wait
    },
    {
      path: '/fail',
      name: 'fail',
      component: fail
    },
    {
      path: '/enterprise',
      name: 'enterprise',
      component: enterprise
    },
    {
      path: '/c_login',
      name: 'c_login',
      component: c_login
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: myOrder
    },
    {
      path: '/posDetails',
      name: 'posDetails',
      component: posDetails
    },
    {
      path: '/Review',
      name: 'Review',
      component: Review
    },
    {
      path: '/my',
      name: 'my',
      component: my
    },
    {
      path: '/Reviewlook',
      name: 'Reviewlook',
      component: Reviewlook
    },
    {
      path: '/getorderhall',
      name: 'getorderhall',
      component: getorderhall
    },
    {
      path: '/situation',
      name: 'situation',
      component: situation
    },
    {
      path: '/borrowmoney',
      name: 'borrowmoney',
      component: borrowmoney
    },
    {
      path: '/xieyi',
      name: 'xieyi',
      component: xieyi
    },
    {
      path: '/bankcard',
      name: 'bankcard',
      component: bankcard
    },
    {
      path: '/replacecard',
      name: 'replacecard',
      component: replacecard
    },
    {
      path: '/newlogin',
      name: 'newlogin',
      component: newlogin,
      meta: {
        title: '用户登录'
      }
    },
    {
      path: '/neworder',
      name: 'neworder',
      component: neworder
    }
  ]
})
export default router

router.beforeEach((to, from, next) => {
  console.log(from)
  // 进入首屏页
  if (to.name === 'loading') {
    let params = util.parseQuery(window.location.href)
    console.log(params)
    let idnum = ''
    // 获取openid
    if (params.id) {
      console.log('有Id', params.id)
      idnum = params.id.split('#')[0]
      if (idnum) {
        util.setStore('OPENID', idnum)
        setopenid(idnum)
      }
    }
    if (util.getStore('OPENID')) {
      // 有缓存
      setopenid(util.getStore('OPENID'))
      console.log('获取本地缓存')
      next()
    } else {
      // 没有缓存
      console.log('没有缓存去授权')
      next()
      // getid(function (data) {
      //   let id = idnum
      //   let gbk = data.gbk
      //   let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + gbk + '&response_type=code&scope=snsapi_userinfo&state=' + id + '#wechat_redirect'
      //   // alert(url)
      //   window.location.href = url
      // })
    }
  } else {
    next()
  }

  // 禁止回退到loading页
  if (from.name && (to.name === 'loading')) {
    console.log('回退到了LOADING')
    next({ path: from.path })
  }
})
document.title = appName



// WEBPACK FOOTER //
// ./src/router/index.js